import { useState } from "react";
import type { GetProps } from "tamagui";

import { LinkText, Text } from "./Typography";

type TruncatedTextProps = {
  text: string;
  maxLength: number;
} & GetProps<typeof Text>;

export default function TruncatedText({
  text,
  maxLength,
  ...textProps
}: TruncatedTextProps) {
  const [isCurrentlyTruncated, setIsCurrentlyTruncated] = useState(true);
  const shouldTruncate = text.length > maxLength;
  const truncatedText = text.slice(0, maxLength);

  if (!shouldTruncate) {
    return <Text {...textProps}>{text}</Text>;
  }

  return isCurrentlyTruncated ? (
    <Text {...textProps}>
      {truncatedText.trim() + "... "}
      <LinkText onPress={() => setIsCurrentlyTruncated(false)}>
        read more
      </LinkText>
    </Text>
  ) : (
    <Text {...textProps}>
      {text.trim() + " "}
      <LinkText onPress={() => setIsCurrentlyTruncated(true)}>
        show less
      </LinkText>
    </Text>
  );
}
